import React, { useEffect, useState, useMemo, useDeferredValue, useRef, useCallback } from "react"
import API from "../../Common/API"
import InlineTextField from "../../Components/InLineTextField";
import { datatableTheme } from "../../Common/dataTableTheme"
import DataTable, { createTheme } from "react-data-table-component"
import { motion } from 'framer-motion'
import { useHistory, useLocation } from "react-router-dom";
import { FaPlus } from "react-icons/fa6";
import { FiCreditCard, FiImage } from "react-icons/fi";
import { HiOutlineEye, HiOutlineKey, HiOutlinePencilSquare, HiOutlinePhoto, HiOutlineTrash, HiOutlineArrowPathRoundedSquare, HiOutlineDocumentArrowDown } from "react-icons/hi2";
import { RiWhatsappLine } from "react-icons/ri";
import Dialog from '../../Components/Dialog'
import Button from "../../Components/Button";
import { useDispatch } from "react-redux";
import { setAlert } from "../../Store/Theme/actions";
import * as Yup from 'yup'
import { useFormik } from "formik";
import dummy from '../../Assets/Images/dummyProfile.jpeg'
import FieldSelect from "../../Components/FieldSelect";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import UserStatusDropdown from "../../Components/UserStatusDropdown";
import UserRowActionsMenu from "../../Components/UserRowActionsMenu";
import UserListSlideOvers from "./UserListSlideOvers";
import WhatsAppMatchShareDialog from "./WhatsAppMatchShareDialog";
import UsersMobileList from "./UsersMobileList";

createTheme('defaultLight', datatableTheme.default)
createTheme('defaultDark', datatableTheme.dark)
const status = [{ id: 0, value: 'Pending' }, { id: 1, value: 'Approved' }, { id: 2, value: 'Declined' }, { id: 3, value: 'In-active' }, { id: 4, value: '💍 Married' }, { id: 5, value: 'Blocked' }, {id:6, value:'Under Review'}]

/* ─── New-user read tracking (stored in localStorage) ─────────────────────── */
const VIEWED_KEY = "rkm_viewed_users"
const getViewedIds = () => { try { return new Set(JSON.parse(localStorage.getItem(VIEWED_KEY) || "[]")) } catch { return new Set() } }
const markAsViewed = (id) => { try { const s = getViewedIds(); s.add(id); localStorage.setItem(VIEWED_KEY, JSON.stringify([...s])) } catch {} }
// NEW badge: only show for members who registered TODAY (same calendar day)
const isNewUser = (user) => {
    if (!user?.createdAt) return false
    const today = new Date(); today.setHours(0,0,0,0)
    return new Date(user.createdAt).getTime() >= today.getTime()
}
const registeredAgo = (createdAt) => {
    if (!createdAt) return 'Registered today'
    const days = Math.floor((Date.now() - new Date(createdAt).getTime()) / 86400000)
    if (days === 0) return 'Registered today'
    return `Registered ${days} day${days !== 1 ? 's' : ''} ago`
}
const statusFilters = [
    { value: 'all', label: 'All Users' },
    { value: 'active', label: 'Active' },
    { value: 'deactivated', label: 'Deactivated' },
    { value: 'pending', label: 'Pending' },
    { value: 'approved', label: 'Approved' },
    { value: 'declined', label: 'Declined' },
    { value: 'underReview', label: 'Under Review' },
    { value: 'paid', label: 'Paid Members' },
    { value: 'married', label: '💍 Married' },
]
const USERS_CACHE_KEY = 'matrimony_users_list'
const PLANS_CACHE_KEY = 'matrimony_plans_list'

const initialActivePlans = {
    planId: '',
    userId: '',
    // planValidityDate: new Date(Date.now() + planDetails.planValidity * 24 * 60 * 60 * 1000),
    planValidityDate: '',
    downloadCount: 0,
}

const readCache = (key) => {
    try {
        const cached = sessionStorage.getItem(key)
        return cached ? JSON.parse(cached) : null
    } catch {
        return null
    }
}

const writeCache = (key, value) => {
    try {
        sessionStorage.setItem(key, JSON.stringify(value))
    } catch {
        // Ignore storage errors so API rendering still works.
    }
}

const normalizePhoneDigits = (value) => (value || '').toString().replace(/\D/g, '')

const prepareUsersForSearch = (users = []) => {
    return users.map((user) => ({
        ...user,
        __searchText: [
            user?.refId,
            user?.firstName,
            user?.lastName,
            user?.surname,
            user?.profileType,
            user?.status,
            user?.activeStat,
            user?.contactInformation?.mobileNumber,
            normalizePhoneDigits(user?.contactInformation?.mobileNumber),
            user?.contactInformation?.whatsappNumber,
            normalizePhoneDigits(user?.contactInformation?.whatsappNumber),
            user?.contactInformation?.email,
            user?.familyInformation?.fatherNative,
        ].filter(Boolean).join(' ').toLowerCase(),
        __firstNameSearch: user?.firstName?.toLowerCase() || '',
        __refIdSearch: user?.refId?.toLowerCase() || '',
        __mobileSearch: normalizePhoneDigits(user?.contactInformation?.mobileNumber),
    }))
}

const normalizeUsersResponse = (payload) => {
    const source = payload?.data || payload
    if (Array.isArray(source)) return source
    if (Array.isArray(source?.users)) return source.users
    if (Array.isArray(source?.data)) return source.data
    if (Array.isArray(source?.docs)) return source.docs
    if (Array.isArray(source?.results)) return source.results
    return []
}

const isMarried = (user) => {
    const s = user?.status
    const sStr = String(s ?? '').toLowerCase()
    return s === 4 || sStr === 'happy customer' || sStr === 'married'
}

const matchesStatusFilter = (user, statusFilter) => {
    const s = user?.status
    const sStr = String(s ?? '').toLowerCase()
    // "All Users" hides married/happy-customer profiles by default
    if (statusFilter === 'all') return !isMarried(user)
    if (statusFilter === 'married') return isMarried(user)
    if (statusFilter === 'active') return user?.activeStat === 'A' && !isMarried(user)
    if (statusFilter === 'deactivated') return user?.activeStat !== 'A' && !isMarried(user)
    if (statusFilter === 'pending') return s === 0 || sStr === 'pending'
    if (statusFilter === 'approved') return s === 1 || sStr === 'approved'
    if (statusFilter === 'declined') return s === 2 || sStr === 'declined'
    if (statusFilter === 'underReview') return s === 6 || sStr === 'underreview'
    if (statusFilter === 'paid') {
        if (!user?.isPaid || !user?.planValidityDate) return Boolean(user?.planActive)
        return new Date(user.planValidityDate) > new Date()
    }
    return true
}

const getUserImages = (user) => {
    const images = user?.images?.length > 0 ? user.images : user?.previewUrls || []
    return images.filter((image) => image?.imageUrl)
}

const normalizeStatus = (s) => {
    if (s === 'Approved'  || s === 'approved')  return 1
    if (s === 'Pending'   || s === 'pending')   return 0
    if (s === 'Declined'  || s === 'declined')  return 2
    if (s === 'Active'    || s === 'active')    return 1
    if (s === 'Under Review' || s === 'under review' || s === 'underreview' || s === 'Verified' || s === 'verified') return 6
    if (s === 'Married'   || s === 'married' ||
        s === 'Happy Customer' || s === 'happy customer') return 4
    return typeof s === 'number' ? s : parseInt(s, 10) || 0
}

const ALL_VERIFICATION_OPTIONS = [
    { value: 0, label: 'Pending' },
    { value: 1, label: 'Approved' },
    { value: 2, label: 'Declined' },
    { value: 6, label: 'Under Review' },
    { value: 4, label: '💍 Married' },
]

const getVerificationStatusOptions = (currentStatus) => {
    // Always show full list — admin can change any status including married
    return ALL_VERIFICATION_OPTIONS
}

const Users = () => {

    const cachedUsers = readCache(USERS_CACHE_KEY)
    const cachedPlans = readCache(PLANS_CACHE_KEY)
    const cachedUserList = normalizeUsersResponse(cachedUsers)
    const [loading, setLoading] = useState(cachedUserList.length === 0)
    const [fetchError, setFetchError] = useState(null)
    const [filter, setFilter] = useState('')
    const deferredFilter = useDeferredValue(filter)
    const [userList, setUserList] = useState(() => prepareUsersForSearch(cachedUserList))
    const history = useHistory()
    const location = useLocation()
    const [userId, setUserId] = useState()
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [openActiveModal, setOpenActiveModal] = useState(false)
    const dispatch = useDispatch()
    const [openchangeStatus, setOpenChangeStatus] = useState(false)
    const [count, setCount] = useState(0)
    const [plans, setPlans] = useState(() => (cachedPlans || []).map((c) => ({ text: c.planName, value: c._id })))
    const [planDetails, setPlanDetails] = useState(() => cachedPlans || [])
    const [userPlans, setUserPlans] = useState([])
    const [genderFilter,setGenderFilter] = useState("")
    const [statusFilter, setStatusFilter] = useState("all")
    const [openCreateUser, setOpenCreateUser] = useState(false)
    const [selectedDetailUser, setSelectedDetailUser] = useState(null)
    const [selectedEditUser, setSelectedEditUser] = useState(null)
    const [lastDetailUser, setLastDetailUser] = useState(null)
    const [selectedPasswordUser, setSelectedPasswordUser] = useState(null)
    const [selectedMatchTargetUser, setSelectedMatchTargetUser] = useState(null)
    const [selectedManageImagesUser, setSelectedManageImagesUser] = useState(null)
    const [createUserActions, setCreateUserActions] = useState(null)
    const [editUserActions, setEditUserActions] = useState(null)
    const [statusUpdatingId, setStatusUpdatingId] = useState(null)
    const [planUpdatingUserId, setPlanUpdatingUserId] = useState(null)
    const [viewedIds, setViewedIds] = useState(() => getViewedIds())

    // Marriage dialog state
    const [marriageDialogUser, setMarriageDialogUser] = useState(null)
    const [marriageType, setMarriageType] = useState(null) // 'rk' | 'outside' | null
    const [partnerQuery, setPartnerQuery] = useState('')
    const [partnerResults, setPartnerResults] = useState([])
    const [partnerLoading, setPartnerLoading] = useState(false)
    const [selectedPartner, setSelectedPartner] = useState(null)
    const [marriageSaving, setMarriageSaving] = useState(false)
    const partnerTimerRef = useRef(null)

    const closeCreateUser = () => {
        setOpenCreateUser(false)
        if (location.search.includes('add=1')) {
            history.replace('/user')
        }
    }

  const fetchUsers = async ({ showLoader = false } = {}) => {
    if (showLoader && userList.length === 0) setLoading(true)
    setFetchError(null)
    try {
      // Fetch all users by paging through backend results (max 200 per request)
      const LIMIT = 200
      let page = 1
      let allUsers = []
      while (true) {
        const response = await API.get(`/user/getUserList`, {
          params: { page, limit: LIMIT, search: '' }
        })
        if (response.status !== 200) break
        const payload = response.data?.data || response.data
        const users = normalizeUsersResponse(payload)
        allUsers = [...allUsers, ...users]
        const total = payload?.total || allUsers.length
        if (allUsers.length >= total || users.length < LIMIT) break
        page++
      }
      writeCache(USERS_CACHE_KEY, allUsers)
      setUserList(prepareUsersForSearch(allUsers))
    } catch (error) {
      console.error("Error fetching users:", error)
      const status = error?.response?.status
      if (status === 401 || status === 403) {
        setFetchError('Session expired or access denied. Please log out and log back in.')
      } else if (!error?.response) {
        setFetchError('Cannot reach the server. Make sure the backend is running on port 5001.')
      } else {
        setFetchError(`Failed to load users (${status || error.message}). Try refreshing.`)
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchUsers({ showLoader: true })
  }, [count]) // eslint-disable-line

  useEffect(() => {
    if (location.search.includes('add=1')) {
        setOpenCreateUser(true)
    }
  }, [location.search])



    useEffect(() => {
        // Always refresh user subscriptions so external plan changes (member payment,
        // another admin session) are visible immediately without requiring a page action.
        const subsTimer = setTimeout(() => {
            API.get('/plans/getAllUserPlan').then((planRes) => {
                if (planRes.status === 200) setUserPlans(planRes.data.data || [])
            }).catch(() => {})
        }, userList.length > 0 ? 800 : 1800)

        // Plan configs are stable — use cache on first load, refresh on subsequent actions
        if (!(cachedPlans?.length > 0 && count === 0)) {
            const configTimer = setTimeout(() => {
                API.get('/plans/getPlansList').then((planRes) => {
                    if (planRes.status === 200) {
                        setPlans(planRes.data.data.map((c) => ({ text: c.planName, value: c._id })))
                        setPlanDetails(planRes.data.data)
                        writeCache(PLANS_CACHE_KEY, planRes.data.data)
                    }
                }).catch(() => {})
            }, userList.length > 0 ? 1200 : 2500)
            return () => { clearTimeout(subsTimer); clearTimeout(configTimer) }
        }

        return () => clearTimeout(subsTimer)
    }, [count]) // eslint-disable-line
    const currentSubscriptionByUserId = useMemo(() => {
        return userPlans.reduce((acc, plan) => {
            const userId = plan?.userId?._id
            if (!userId) return acc
            const previousPlan = acc[userId]
            const previousDate = previousPlan?.planValidityDate ? new Date(previousPlan.planValidityDate) : new Date(0)
            const currentDate = plan?.planValidityDate ? new Date(plan.planValidityDate) : new Date(0)
            if (!previousPlan || currentDate >= previousDate) {
                acc[userId] = plan
            }
            return acc
        }, {})
    }, [userPlans])

    const openWhatsAppShare = (row) => {
        const rawNumber = row?.contactInformation?.whatsappNumber || row?.contactInformation?.mobileNumber || ''
        const cleanNumber = rawNumber.replace(/\D/g, '')

        if (!cleanNumber) {
            dispatch(setAlert({ title: 'Error', subtitle: 'Whatsapp number is not available for this user', active: true, type: 'error' }))
            return
        }

        const formattedNumber = cleanNumber.length === 10 ? `91${cleanNumber}` : cleanNumber
        const currentPlan = currentSubscriptionByUserId[row._id]?.planId?.planName || 'No active plan'
        const message = encodeURIComponent(`Hello ${row?.firstName || ''}, this is Royal Kavery admin support. Ref ID: ${row?.refId || '-'} | Current plan: ${currentPlan}.`)
        window.open(`https://wa.me/${formattedNumber}?text=${message}`, '_blank', 'noopener,noreferrer')
    }

    const updateUserPlan = async (row, planId) => {
        if (!planId || planUpdatingUserId === row?._id) return

        const selectedPlan = planDetails.find((item) => item._id === planId)
        const currentSubscription = currentSubscriptionByUserId[row._id]

        if (!selectedPlan) return
        if (currentSubscription?.planId?._id === planId) return

        const validityDate = new Date(Date.now() + Number(selectedPlan.planValidity || 0) * 24 * 60 * 60 * 1000)

        try {
            setPlanUpdatingUserId(row._id)
            if (currentSubscription?._id) {
                await API.post('/plans/editSubscription', {
                    userId: row._id,
                    planId,
                    planValidityDate: validityDate.toISOString().split('T')[0],
                })
            } else {
                await API.post('/plans/subscribe', {
                    userId: row._id,
                    planId,
                    planValidityDate: validityDate.toISOString(),
                    downloadCount: 0,
                })
            }

            dispatch(setAlert({ title: 'Success', subtitle: 'Plan updated successfully', active: true, type: 'success' }))
            setCount((prev) => prev + 1)
        } catch (error) {
            dispatch(setAlert({ title: 'Error', subtitle: 'Unable to update the plan right now', active: true, type: 'error' }))
        } finally {
            setPlanUpdatingUserId(null)
        }
    }

    const columns = useMemo(() => [
        {
            name: 'S.No', selector: (row, i) => i + 1,
            initialActive: true, sortable: true, width: '100px'
        },
        {
            name : <FiImage/>,
            selector:(row,i)=> {
                const userImages = getUserImages(row)
                const primaryImage = userImages[0]?.imageUrl || dummy

                if (userImages.length === 0) {
                    return (
                        <motion.div className="flex h-full w-full items-center justify-center px-2 py-2">
                            <img src={primaryImage} alt="user" className="h-16 w-16 rounded-2xl object-cover ring-1 ring-borderColor" loading="lazy" />
                        </motion.div>
                    )
                }

                return (
                    <motion.div className="flex h-full w-full items-center justify-center px-2 py-2">
                        <PhotoProvider>
                            {userImages.map((image, imageIndex) => (
                                <PhotoView key={`${row._id}-${imageIndex}`} src={image.imageUrl}>
                                    <button
                                        type="button"
                                        className={imageIndex === 0 ? 'group relative h-16 w-16 overflow-hidden rounded-2xl ring-1 ring-borderColor transition hover:ring-2 hover:ring-primeColor' : 'hidden'}
                                        title="View profile images"
                                        onClick={(event) => event.stopPropagation()}
                                    >
                                        <img src={primaryImage} alt="user" className="h-full w-full object-cover transition group-hover:scale-105" loading="lazy" />
                                        {userImages.length > 1 && (
                                            <span className="absolute bottom-1 right-1 rounded-full bg-slate-950/75 px-2 py-0.5 text-[10px] font-bold text-white">
                                                {userImages.length}
                                            </span>
                                        )}
                                    </button>
                                </PhotoView>
                            ))}
                        </PhotoProvider>
                    </motion.div>
                )
            },
            initialActive: true, sortable: true,
        },
        { name: 'Ref Id', selector: (row, i) => row.refId, initialActive: true, sortable: true, width: '100px' },
        {
            name: 'Name',
            selector: row => `${row.firstName || ''} ${row.surname || ''}`.trim(),
            sortable: true,
            minWidth: '210px',
            cell: row => {
                const isNew = isNewUser(row) && !viewedIds.has(row._id)
                return (
                    <button
                        type="button"
                        className="group flex flex-col text-left py-1"
                        onClick={() => viewUser(row)}
                        title="Open user details"
                    >
                        <span className="flex items-center gap-1.5 font-bold text-tColor transition group-hover:text-primeColor">
                            {row.firstName || '-'} {row.surname ? `(${row.surname})` : ''}
                            {isNew && (
                                <span className="inline-flex items-center rounded-full bg-emerald-500 px-1.5 py-0.5 text-[9px] font-extrabold uppercase tracking-wider text-white animate-pulse">
                                    NEW
                                </span>
                            )}
                        </span>
                        <span className="text-xs font-medium text-tpColor transition group-hover:text-primeColor">
                            {isNew ? registeredAgo(row.createdAt) : "View profile details"}
                        </span>
                    </button>
                )
            }
        },
        // { name: 'Native', selector: row => row.familyInformation.fatherNative, sortable: true },
        {
            name: 'Mobile / Login ID',
            selector: row => row?.contactInformation?.mobileNumber,
            sortable: true,
            minWidth: '190px',
            cell: row => (
                <div className="flex flex-col py-2 text-left">
                    <span className="font-semibold text-tColor">{row?.contactInformation?.mobileNumber || '-'}</span>
                    <span className="text-xs font-medium text-tpColor">Use this mobile number for member login</span>
                </div>
            )
        },
        {
            name: 'Plan Name',
            minWidth: '240px',
            selector: row => currentSubscriptionByUserId[row._id]?.planId?.planName || 'No Plan',
            cell: (row) => {
                const currentSubscription = currentSubscriptionByUserId[row._id]
                const isUpdating = planUpdatingUserId === row._id

                return (
                    <div className="flex w-full flex-col gap-2 py-2">
                        <select
                            className="min-h-[42px] rounded-xl border border-borderColor bg-white px-3 py-2 text-sm font-semibold text-tColor shadow-sm outline-none transition focus:border-primeColor"
                            value={currentSubscription?.planId?._id || ''}
                            onChange={(event) => updateUserPlan(row, event.target.value)}
                            disabled={isUpdating}
                        >
                            <option value="">No Plan</option>
                            {planDetails.map((plan) => (
                                <option key={plan._id} value={plan._id}>
                                    {plan.planName}
                                </option>
                            ))}
                        </select>
                        <span className="text-xs font-medium text-tpColor">
                            {isUpdating ? 'Updating plan...' : currentSubscription?.planValidityDate ? `Valid till ${new Date(currentSubscription.planValidityDate).toLocaleDateString()}` : 'Assign a plan directly from the list'}
                        </span>
                    </div>
                )
            }
        },
        {
            name: "Verification Status",
            selector: row => (
                <UserStatusDropdown
                    value={normalizeStatus(row.status)}
                    options={getVerificationStatusOptions(row.status)}
                    loading={statusUpdatingId === row._id}
                    onChange={(nextStatus) => updateVerificationStatus(row, nextStatus)}
                />
            ),
            sortable: true,
            minWidth: '220px',
        },
        { name: "Status", selector: row => {
            if (isMarried(row)) return (
                <span className="status-pill" style={{ background: '#f1efff', color: '#5947b6', border: '1px solid #d8d3f5' }}>
                    CLOSED
                </span>
            )
            return <span className={`status-pill ${row.activeStat === 'A' ? 'status-pill--success' : 'status-pill--danger'}`}>{row.activeStat === 'A' ? "ACTIVE" : "DEACTIVATED"}</span>
        }, sortable: true },
        {
            name: "Action",
            width: '110px',
            selector: row => (
                <div className="flex w-full justify-center">
                    <UserRowActionsMenu
                        actions={[
                            { label: 'View Details', icon: HiOutlineEye, onClick: () => viewUser(row) },
                            { label: 'Edit User', icon: HiOutlinePencilSquare, onClick: () => editUser(row) },
                            !isMarried(row) && { label: 'Change Password', icon: HiOutlineKey, onClick: () => setSelectedPasswordUser(row) },
                            { label: 'Manage Images', icon: HiOutlinePhoto, onClick: () => setSelectedManageImagesUser(row) },
                            { label: 'Download PDF', icon: HiOutlineDocumentArrowDown, onClick: () => {
                                const win = window.open(`/view/${row._id}?autoprint=1`, '_blank')
                                if (!win) dispatch(setAlert({ title: 'Pop-up blocked', subtitle: 'Please allow pop-ups to download the PDF.', type: 'error', active: true }))
                            } },
                            !isMarried(row) && { label: 'Share on WhatsApp', icon: RiWhatsappLine, onClick: () => openWhatsAppShare(row) },
                            !isMarried(row) && { label: 'Send Matching Profiles', icon: RiWhatsappLine, onClick: () => setSelectedMatchTargetUser(row) },
                            !isMarried(row) && { label: currentSubscriptionByUserId[row._id]?.planId ? 'Manage Plan' : 'Activate Plan', icon: FiCreditCard, onClick: () => openStatuses(row) },
                            !isMarried(row) && (row.activeStat === 'A'
                                ? { label: 'Deactivate User', icon: HiOutlineTrash, danger: true, onClick: () => deactivateUser(row) }
                                : { label: 'Activate User', icon: HiOutlineArrowPathRoundedSquare, onClick: () => activateUser(row) }),
                        ].filter(Boolean)}
                    />
                </div>
            ), sortable: false
        },
    ], [statusUpdatingId, currentSubscriptionByUserId, planDetails, planUpdatingUserId])// eslint-disable-line

   const filteredcasedetails = useMemo(() => {
    const normalizedFilter = deferredFilter.toLowerCase().trim();
    const filterSplit = normalizedFilter.split(' ').filter(Boolean);
    const digitFilter = normalizePhoneDigits(deferredFilter);

    const firstNameMatches = [];
    const refIdMatches = [];
    const mobileMatches = [];
    const otherMatches = [];

    userList.forEach((user) => {
        const profile = user?.profileType?.toLowerCase?.() || ''; // "groom" or "bride"

        // Apply gender filter
        if (genderFilter && profile !== genderFilter.toLowerCase()) {
            return;
        }

        if (!matchesStatusFilter(user, statusFilter)) {
            return;
        }

        const firstName = user.__firstNameSearch || '';
        const refId = user.__refIdSearch || '';
        const mobile = user.__mobileSearch || '';
        const searchString = user.__searchText || '';

        const matchesAll = filterSplit.every((kw) => searchString.includes(kw));
        const matchesDigitSearch = digitFilter ? mobile.includes(digitFilter) : false;

        if (matchesAll || matchesDigitSearch) {
            const firstNameMatchesAll = filterSplit.every((kw) => firstName.includes(kw));
            const refIdMatchesAll = filterSplit.every((kw) => refId.includes(kw));

            if (firstNameMatchesAll) {
                firstNameMatches.push(user);
            } else if (refIdMatchesAll) {
                refIdMatches.push(user);
            } else if (matchesDigitSearch) {
                mobileMatches.push(user);
            } else {
                otherMatches.push(user);
            }
        }
    });

    return [...firstNameMatches, ...refIdMatches, ...mobileMatches, ...otherMatches];
}, [userList, deferredFilter, genderFilter, statusFilter]);

    const SubHeader = useMemo(() => (
        <div className="table-toolbar">
            <div className="toolbar-actions">
            <motion.button type="button" className="inline-flex min-h-[46px] items-center rounded-2xl bg-primeColor px-5 py-3 text-sm font-bold text-white shadow-soft transition hover:bg-primeDark" onClick={()=>downloadAsExcel()}>Export Excel</motion.button>
            <select
                className="min-h-[46px] rounded-2xl border border-borderColor bg-white/90 px-4 py-2 text-sm font-bold text-tColor shadow-soft focus:outline-none"
                value={genderFilter}
                onChange={(e) => setGenderFilter(e.target.value)}
            >
                <option value="">All</option>
                <option value="groom">Male</option>
                <option value="bride">Female</option>
            </select>

            </div>
            <div className="flex w-full flex-wrap items-center gap-2 md:w-auto">
                {statusFilters.map((item) => (
                    <button
                        key={item.value}
                        type="button"
                        className={`rounded-full border px-3 py-2 text-xs font-bold transition ${statusFilter === item.value ? 'border-primeColor bg-primeColor text-white shadow-sm' : 'border-borderColor bg-white text-tpColor hover:border-primeColor hover:text-primeColor'}`}
                        onClick={() => setStatusFilter(item.value)}
                    >
                        {item.label}
                    </button>
                ))}
            </div>
            <div className="toolbar-actions">
            <InlineTextField label={"Users"} placeholder={"Search by name, ref id, or mobile number"} value={filter} setValue={setFilter} />
            <motion.button type="button" className="flex h-[46px] w-[46px] items-center justify-center rounded-2xl bg-tColor text-white shadow-soft transition hover:bg-primeColor" onClick={() => setOpenCreateUser(true)}><FaPlus /></motion.button>
            </div>
        </div>
    ), [filter,genderFilter,statusFilter])// eslint-disable-line

    const editUser = (values) => {
        setSelectedEditUser(values)
    }

    const viewUser = (values) => {
        if (values?._id && isNewUser(values) && !viewedIds.has(values._id)) {
            markAsViewed(values._id)
            setViewedIds(getViewedIds())
        }
        setSelectedDetailUser(values)
    }
    const deactivateUser = (values) => {
        setUserId(values._id)
        setOpenDeleteModal(true)
    }

    const activateUser = (values) => {
        setUserId(values._id)
        setOpenActiveModal(true)
    }

    const openStatuses = (row) => {
        setOpenChangeStatus(true)
        planForm.setValues({ ...planForm.values, userId: row._id })
    }

    // Partner search for RK marriage
    useEffect(() => {
        clearTimeout(partnerTimerRef.current)
        if (!partnerQuery.trim() || marriageType !== 'rk') { setPartnerResults([]); return }
        partnerTimerRef.current = setTimeout(async () => {
            setPartnerLoading(true)
            try {
                const res = await API.get('/user/getUserList', { params: { page: 1, limit: 15, search: partnerQuery.trim() } })
                const docs = res.data?.data?.docs || res.data?.data || []
                const list = Array.isArray(docs) ? docs : []
                // Exclude the user being marked and already-married profiles
                setPartnerResults(list.filter((u) => u._id !== marriageDialogUser?._id && u.status !== 4 && u.status !== 'Married'))
            } catch { setPartnerResults([]) }
            finally { setPartnerLoading(false) }
        }, 350)
        return () => clearTimeout(partnerTimerRef.current)
    }, [partnerQuery, marriageType, marriageDialogUser]) // eslint-disable-line

    const openMarriageDialog = useCallback((row) => {
        setMarriageDialogUser(row)
        setMarriageType(null)
        setPartnerQuery('')
        setPartnerResults([])
        setSelectedPartner(null)
    }, [])

    const closeMarriageDialog = () => {
        setMarriageDialogUser(null)
        setMarriageType(null)
        setPartnerQuery('')
        setPartnerResults([])
        setSelectedPartner(null)
    }

    const confirmMarriage = async () => {
        if (!marriageDialogUser || !marriageType) return
        if (marriageType === 'rk' && !selectedPartner) return
        setMarriageSaving(true)
        try {
            const payload = {
                userId: marriageDialogUser._id,
                marriageType,
                partnerId: marriageType === 'rk' ? selectedPartner._id : null,
            }
            const res = await API.post('/user/makeHappyCustomer', payload)
            if (res.status === 200) {
                dispatch(setAlert({ title: 'Success', subtitle: 'Marked as Married (Happy Customer)', active: true, type: 'success' }))
                closeMarriageDialog()
                setCount((prev) => prev + 1)
            }
        } catch {
            dispatch(setAlert({ title: 'Error', subtitle: 'Unable to update status right now', active: true, type: 'error' }))
        } finally {
            setMarriageSaving(false)
        }
    }

    const updateVerificationStatus = async (row, nextStatus) => {
        if (normalizeStatus(row?.status) === nextStatus || statusUpdatingId === row?._id) return

        // Status 4 = Married → open marriage dialog
        if (nextStatus === 4) {
            openMarriageDialog(row)
            return
        }

        let endpoint = null
        let successSubtitle = 'Status updated successfully'

        if (nextStatus === 0) {
            endpoint = `/user/moveToPending/${row._id}`
            successSubtitle = 'Profile moved to pending successfully'
        } else if (nextStatus === 1) {
            endpoint = (normalizeStatus(row.status) === 6) ? `/user/verifyProfile/${row._id}` : `/user/approveUser/${row._id}`
            successSubtitle = 'Profile approved successfully'
        } else if (nextStatus === 2) {
            endpoint = `/user/declineUser/${row._id}`
            successSubtitle = 'Profile declined successfully'
        } else if (nextStatus === 6) {
            endpoint = `/user/underReview/${row._id}`
            successSubtitle = 'Profile moved to Under Review'
        }

        if (!endpoint) return

        try {
            setStatusUpdatingId(row._id)
            const response = await API.get(endpoint)
            if (response.status === 200) {
                dispatch(setAlert({ title: 'Success', subtitle: successSubtitle, active: true, type: 'success' }))
                setCount((prev) => prev + 1)
            }
        } catch (error) {
            dispatch(setAlert({ title: 'Error', subtitle: 'Unable to update status right now', active: true, type: 'error' }))
        } finally {
            setStatusUpdatingId(null)
        }
    }

    const deleteUser = () => {
        try {
            API.post(`/user/deactivateUser/${userId}`).then((deRes) => {
                if (deRes.status === 200) {
                    dispatch(setAlert({ title: 'Success', subtitle: 'User Deactivated Successfully', active: true, type: 'success' }))
                    setOpenDeleteModal(false)
                    setCount(count + 1)
                }
            })
        } catch (err) {
            dispatch(setAlert({ title: 'Error', subtitle: 'Something went wrong', active: true, type: 'error' }))
        }
    }

    const reactiveUser = () => {
        try {
            API.post(`/user/activateUser/${userId}`).then((deRes) => {
                if (deRes.status === 200) {
                    dispatch(setAlert({ title: 'Success', subtitle: 'User activated Successfully', active: true, type: 'success' }))
                    setOpenActiveModal(false)
                    setCount(count + 1)
                }
            })
        } catch (err) {
            dispatch(setAlert({ title: 'Error', subtitle: 'Something went wrong', active: true, type: 'error' }))
        }
    }

    const planFormSchema = Yup.object().shape({
        planId: Yup.string().required("Choose plan Id")
    })

    const planForm = useFormik({
        initialValues: initialActivePlans,
        validateOnMount: true,
        validationSchema: planFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
        }
    })


    const activatePlan = () => {
        const selectedPlan = planDetails.find((x) => x._id === planForm.values.planId)
        if (!selectedPlan) {
            dispatch(setAlert({ title: "Error", subtitle: 'Please select a plan first', active: true, type: 'error' }))
            return
        }
        const validityDays = Number(selectedPlan.validityInDays || selectedPlan.planValidity)
        if (!validityDays || isNaN(validityDays)) {
            dispatch(setAlert({ title: "Error", subtitle: 'Selected plan has no valid validity period', active: true, type: 'error' }))
            return
        }
        const planValidityDate = new Date(Date.now() + validityDays * 24 * 60 * 60 * 1000).toISOString()
        const apiValues = {
            planId: planForm.values.planId,
            userId: planForm.values.userId,
            planValidityDate,
            downloadCount: 0,
        }
        API.post('/plans/subscribe', apiValues).then((subRes) => {
            if (subRes.status === 200) {
                dispatch(setAlert({ title: "Success", subtitle: 'Plan Activated Successfully', active: true, type: 'success' }))
                setCount(count + 1)
                setOpenChangeStatus(false)
            }
        }).catch((err) => {
            dispatch(setAlert({ title: "Error", subtitle: 'Something went wrong', active: true, type: 'error' }))
        })
    }


    const downloadAsExcel = async ()=>{
        try{
            const response = await API.get(`/user/xlsxUsersDownload`, {
                responseType: 'blob', // Ensure response is treated as a Blob
            })

            if (response.status === 200) {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `UsersList.xlsx`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }
        }catch(err){    
            console.log(err)
            dispatch(setAlert({title:'Error',subtitle:'Something went wrong while downloading',active:true,type:'error'}))
        }
    }

    return (
        <motion.div className="space-y-5">
            {/* Mobile-only toolbar (sticks above the cards) */}
            <div className="md:hidden">{SubHeader}</div>

            {/* Mobile card list — shown below md breakpoint */}
            <div className="md:hidden">
                <UsersMobileList
                    users={filteredcasedetails}
                    onCopyMobile={(mobile) => {
                        if (!mobile) return
                        try {
                            navigator.clipboard.writeText(mobile)
                            dispatch(setAlert({ title: 'Copied', subtitle: `${mobile} copied to clipboard.`, type: 'success', active: true }))
                        } catch (_) { /* ignore */ }
                    }}
                    actions={{
                        view: (row) => viewUser(row),
                        preview: (row) => history.push(`/member-view/${row._id}`),
                        edit: (row) => editUser(row),
                        changePassword: (row) => setSelectedPasswordUser(row),
                        manageImages: (row) => setSelectedManageImagesUser(row),
                        whatsappShare: (row) => openWhatsAppShare(row),
                        sendMatching: (row) => setSelectedMatchTargetUser(row),
                        activatePlan: (row) => openStatuses(row),
                        pdf: (row) => {
                            const win = window.open(`/view/${row._id}?autoprint=1`, '_blank')
                            if (!win) dispatch(setAlert({ title: 'Pop-up blocked', subtitle: 'Please allow pop-ups to download the PDF.', type: 'error', active: true }))
                        },
                        approve: (row) => updateVerificationStatus(row, 1),
                        decline: (row) => updateVerificationStatus(row, 2),
                        activate: (row) => activateUser(row),
                        deactivate: (row) => deactivateUser(row),
                    }}
                />
            </div>

            {/* Fetch error banner */}
            {fetchError && (
                <div className="flex items-center justify-between rounded-2xl border border-red-200 bg-red-50 px-5 py-4 text-sm font-medium text-red-700 shadow-sm">
                    <span>⚠️ {fetchError}</span>
                    <button
                        type="button"
                        className="ml-4 rounded-xl bg-red-100 px-4 py-2 text-xs font-bold text-red-700 transition hover:bg-red-200"
                        onClick={() => fetchUsers({ showLoader: true })}
                    >
                        Retry
                    </button>
                </div>
            )}

            {/* Desktop data table — hidden below md */}
            <motion.div className="datatable-shell panel-card hidden h-full w-full overflow-hidden md:block">
                <DataTable
                    title="User List"
                    theme="defaultLight"
                    columns={columns}
                    data={filteredcasedetails}
                    pagination
                    progressPending={loading && userList.length === 0}
                    progressComponent={
                        <div className="flex min-h-[180px] w-full flex-col items-center justify-center gap-3 text-tpColor">
                            <div className="h-8 w-8 animate-spin rounded-full border-4 border-lightGrey border-t-primeColor" />
                            <p className="text-sm font-medium">Loading users...</p>
                        </div>
                    }
                    highlightOnHover
                    selectableRowsHighlight
                    persistTableHead
                    subHeader
                    subHeaderComponent={SubHeader}
                    noDataComponent={'There are no records to display'}
                />
            </motion.div>
            {/* <Dialog injectClass={'min-w-screen'} showDialog={openEditModal} title={'Edit User'} onClose={() => setOpenEditModal(false)}>
                <PreviewUser registerValues={userId} onClose={() => setOpenEditModal(false)} />
            </Dialog> */}
            <Dialog injectClass="w-350px" showDialog={openchangeStatus} title={'Activate Plan'} onClose={() => setOpenChangeStatus(false)}>
                <motion.div className="w-full flex flex-col">
                    <FieldSelect label={'Choose Plan'} fieldProps={planForm.getFieldProps('planId')} fieldHelper={planForm.getFieldHelpers('planId')} fieldMeta={planForm.getFieldMeta('planId')} edit={true} dataLoaded={true} options={plans} />
                    <motion.div className="w-full flex flex-row justify-between mt-3">
                        <Button type="secondary" injectClass="rounded-full" onClick={() => setOpenChangeStatus(false)}>Cancel</Button>
                        <Button type="primary" injectClass="rounded-full" onClick={() => activatePlan()}>Activate</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
            <Dialog injectClass="w-350px" showDialog={openActiveModal} title={'Activate User'} onClose={() => setOpenActiveModal(false)}>
                <motion.div className="w-full flex flex-col">
                    Are you sure you want to activate this user.
                    <motion.div className="w-full flex flex-row justify-between mt-3">
                        <Button type="secondary" injectClass="rounded-full" onClick={() => setOpenActiveModal(false)}>No</Button>
                        <Button type="primary" injectClass="rounded-full" onClick={() => reactiveUser()}>Yes</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
            <Dialog injectClass="w-350px" showDialog={openDeleteModal} title={'Deactivate User'} onClose={() => setOpenDeleteModal(false)}>
                <motion.div className="w-full flex flex-col">
                    Are you sure you want to deactivate this user.
                    <motion.div className="w-full flex flex-row justify-between mt-3">
                        <Button type="secondary" injectClass="rounded-full" onClick={() => setOpenDeleteModal(false)}>No</Button>
                        <Button type="danger" injectClass="rounded-full" onClick={() => deleteUser()}>Yes</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
            <UserListSlideOvers
                openCreateUser={openCreateUser}
                createSubtitle="Create a member profile from here, then return to the filtered list automatically."
                onCloseCreate={closeCreateUser}
                onCreated={() => {
                    closeCreateUser()
                    setCount(count + 1)
                }}
                createUserActions={createUserActions}
                onCreateActionsReady={setCreateUserActions}
                selectedDetailUser={selectedDetailUser}
                onCloseDetail={() => setSelectedDetailUser(null)}
                onEditFromDetail={(user) => { setLastDetailUser(user); setSelectedDetailUser(null); setSelectedEditUser(user) }}
                selectedEditUser={selectedEditUser}
                onCloseEdit={() => { setSelectedEditUser(null); if (lastDetailUser) { setSelectedDetailUser(lastDetailUser); setLastDetailUser(null) } }}
                onEditSaved={(savedUser) => {
                    setSelectedEditUser(null)
                    setCount(count + 1)
                    if (lastDetailUser) { setSelectedDetailUser(savedUser || lastDetailUser); setLastDetailUser(null) }
                }}
                editUserActions={editUserActions}
                onEditActionsReady={setEditUserActions}
                selectedPasswordUser={selectedPasswordUser}
                onClosePassword={() => setSelectedPasswordUser(null)}
                selectedManageImagesUser={selectedManageImagesUser}
                onCloseManageImages={() => setSelectedManageImagesUser(null)}
                onManageImagesSaved={(savedImages) => {
                    // Update the user's images in the local list immediately so the
                    // avatar/photo column reflects the new photos without a full re-fetch.
                    setUserList((prev) => prev.map((u) =>
                        u._id === selectedManageImagesUser?._id
                            ? { ...u, images: savedImages }
                            : u
                    ))
                }}
            />
            <WhatsAppMatchShareDialog
                open={Boolean(selectedMatchTargetUser)}
                onClose={() => setSelectedMatchTargetUser(null)}
                targetUser={selectedMatchTargetUser}
                profiles={userList}
            />

            {/* ── Marriage Dialog ─────────────────────────────────────────── */}
            <Dialog
                injectClass="w-[480px]"
                showDialog={Boolean(marriageDialogUser)}
                title="💍 Mark as Married"
                onClose={closeMarriageDialog}
            >
                <div className="flex flex-col gap-5">
                    <p className="text-sm text-tpColor">
                        <span className="font-bold text-tColor">{marriageDialogUser?.firstName} {marriageDialogUser?.surname || marriageDialogUser?.lastName || ''}</span>
                        {' '}({marriageDialogUser?.refId}) — How did they get married?
                    </p>

                    {/* Step 1: choose type */}
                    {!marriageType && (
                        <div className="flex flex-col gap-3">
                            <button
                                type="button"
                                onClick={() => setMarriageType('rk')}
                                className="flex items-center gap-4 rounded-2xl border-2 border-borderColor bg-white px-5 py-4 text-left transition hover:border-primeColor hover:bg-primeColor/5"
                            >
                                <span className="text-2xl">🏠</span>
                                <div>
                                    <p className="font-bold text-tColor">Within Royal Kavery</p>
                                    <p className="text-xs text-tpColor mt-0.5">Married someone from our RK database — select their profile</p>
                                </div>
                            </button>
                            <button
                                type="button"
                                onClick={() => { setMarriageType('outside'); setSelectedPartner(null) }}
                                className="flex items-center gap-4 rounded-2xl border-2 border-borderColor bg-white px-5 py-4 text-left transition hover:border-primeColor hover:bg-primeColor/5"
                            >
                                <span className="text-2xl">🌐</span>
                                <div>
                                    <p className="font-bold text-tColor">Outside / Other</p>
                                    <p className="text-xs text-tpColor mt-0.5">Married someone outside Royal Kavery</p>
                                </div>
                            </button>
                        </div>
                    )}

                    {/* Step 2 (RK): search for partner */}
                    {marriageType === 'rk' && (
                        <div className="flex flex-col gap-3">
                            <button type="button" onClick={() => { setMarriageType(null); setSelectedPartner(null); setPartnerQuery('') }} className="flex items-center gap-1 text-xs text-primeColor font-bold hover:underline w-fit">
                                ← Change type
                            </button>
                            <p className="text-sm font-semibold text-tColor">Search the partner's profile:</p>
                            <input
                                type="text"
                                value={partnerQuery}
                                onChange={(e) => { setPartnerQuery(e.target.value); setSelectedPartner(null) }}
                                placeholder="Name, Ref ID, or mobile…"
                                className="w-full rounded-xl border border-borderColor bg-white px-4 py-2.5 text-sm text-tColor outline-none placeholder:text-tpColor/60 focus:border-primeColor"
                            />
                            {partnerLoading && <p className="text-xs text-tpColor">Searching…</p>}
                            {partnerResults.length > 0 && !selectedPartner && (
                                <div className="flex flex-col gap-1 max-h-48 overflow-y-auto rounded-xl border border-borderColor bg-white p-1">
                                    {partnerResults.map((u) => (
                                        <button
                                            key={u._id}
                                            type="button"
                                            onClick={() => { setSelectedPartner(u); setPartnerResults([]) }}
                                            className="flex items-center gap-3 rounded-lg px-3 py-2 text-left text-sm hover:bg-primeColor/10 transition"
                                        >
                                            <span className="font-bold text-tColor">{u.firstName} {u.surname || u.lastName || ''}</span>
                                            <span className="text-xs text-tpColor">· {u.refId} · {u.profileType}</span>
                                        </button>
                                    ))}
                                </div>
                            )}
                            {selectedPartner && (
                                <div className="flex items-center justify-between rounded-xl border-2 border-primeColor bg-primeColor/5 px-4 py-3">
                                    <div>
                                        <p className="font-bold text-tColor">{selectedPartner.firstName} {selectedPartner.surname || selectedPartner.lastName || ''}</p>
                                        <p className="text-xs text-tpColor">{selectedPartner.refId} · {selectedPartner.profileType}</p>
                                    </div>
                                    <button type="button" onClick={() => { setSelectedPartner(null); setPartnerQuery('') }} className="text-xs text-red-500 font-bold hover:underline">Remove</button>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Step 2 (Outside): confirm message */}
                    {marriageType === 'outside' && (
                        <div className="flex flex-col gap-3">
                            <button type="button" onClick={() => setMarriageType(null)} className="flex items-center gap-1 text-xs text-primeColor font-bold hover:underline w-fit">
                                ← Change type
                            </button>
                            <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
                                This profile will be marked as <strong>Married (Outside RK)</strong> and hidden from all match lists.
                            </div>
                        </div>
                    )}

                    {/* Confirm / Cancel buttons */}
                    {marriageType && (
                        <div className="flex justify-between gap-3 pt-1">
                            <Button type="secondary" injectClass="rounded-full" onClick={closeMarriageDialog}>Cancel</Button>
                            <Button
                                type="primary"
                                injectClass="rounded-full"
                                onClick={confirmMarriage}
                                disabled={marriageSaving || (marriageType === 'rk' && !selectedPartner)}
                            >
                                {marriageSaving ? 'Saving…' : '✓ Confirm Married'}
                            </Button>
                        </div>
                    )}
                </div>
            </Dialog>
        </motion.div>
    )
}

export default Users
